import { render, staticRenderFns } from "./loginChangeTrains.vue?vue&type=template&id=be1a8bcc&"
import script from "./loginChangeTrains.vue?vue&type=script&lang=ts&"
export * from "./loginChangeTrains.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports